"use client";

import { useEffect, useState } from "react";
import PropertyMap, { PropertyMapTypes } from "./PropertyMap";
const PropertyMapWrapper = (props: PropertyMapTypes) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      });
    }, {
      root: null,
      rootMargin: "100px",
      threshold: 0
    });
    const element = (document.getElementById("mapWraper") as HTMLElement);
    if (element) observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return (
    // Min height prevents the CLS issue
    <div id='mapWraper' className='min-h-[264px]' data-sentry-component="PropertyMapWrapper" data-sentry-source-file="PropertyMapWrapper.tsx">
      {isVisible ? <PropertyMap {...props} /> : <></>}
    </div>
  );
};
export default PropertyMapWrapper;